import ProjectManagement from './ProjectManagement.vue'
export default ProjectManagement


// WEBPACK FOOTER //
// ./src/pages/salesManagement/xmgl/index.js